exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".session-create_dropzone_21N {\n  width: 100%;\n  height: 100%;\n  position: relative; }\n", "", {"version":3,"sources":["/Users/nicolaythafvelin/efoil/logger-webapp/src/components/session/session-create.scss"],"names":[],"mappings":"AAIA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB,EAAE","file":"session-create.scss","sourcesContent":[":export {\n  primaryColor: #00bcd4;\n  accentColor: #ff5722; }\n\n.dropzone {\n  width: 100%;\n  height: 100%;\n  position: relative; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"primaryColor": "#00bcd4",
	"accentColor": "#ff5722",
	"dropzone": "session-create_dropzone_21N"
};